import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedUnit, formatUnit } from '../format'
import { providerTypes, propTypes } from '../types'
import {
  METRIC,
  HYBRID,
  KILOMETERS_PER_HOUR,
  MILES_PER_HOUR,
  METERS_PER_SECOND,
  SHORT,
  MINUTE_MI,
  MINUTE_KM,
} from '../constants'

export function getSpeedTo ({ to, system }) {
  if (to) { return to }
  return (system === METRIC || system === HYBRID) ? KILOMETERS_PER_HOUR : MILES_PER_HOUR
}

export function formatSpeed ({ from = METERS_PER_SECOND, unit = SHORT, digits = 0, to: _to, system, ...rest } = {}) {
  const to = getSpeedTo({ from, to: _to, system })
  return formatUnit({ ...rest, from, to, unit, digits })
}

export function speedFormatter ({ intl, locale, system } = {}) {
  return ({ ...options }) => formatSpeed({ ...options, intl, locale, system })
}

export class FormattedSpeed extends Component {
  static contextTypes = providerTypes;

  static propTypes = {
    ...propTypes,
    from: PropTypes.oneOf([ METERS_PER_SECOND, MILES_PER_HOUR, KILOMETERS_PER_HOUR, MINUTE_KM, MINUTE_MI ]),
    to: PropTypes.oneOf([ METERS_PER_SECOND, MILES_PER_HOUR, KILOMETERS_PER_HOUR ]),
  }

  static defaultProps = { from: METERS_PER_SECOND, unit: SHORT, digits: 0 }

  render () {
    const { to: _to, ...rest } = this.props
    const to = getSpeedTo({ to: _to, system: this.context.system })
    return React.createElement(FormattedUnit, { ...rest, to })
  }
}



// WEBPACK FOOTER //
// ./src/shared/units/metrics/speed.js